import functions from "./functions.js";
import { SimpleGuests, SimpleGuestsDefaults } from "./simple-guests.js";
import { FormGuide, FormGuideDefaults } from "./form-guide.js";
import lozad from 'lozad';

$(() =>
{

    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-menu [href], .main-menu-top [href], footer [href], .page-sidebar [href]').each((i, link) =>
    {
        let href = link.getAttribute('href');
        if (href && href != '#')
        {
            href = href.split('?')[0].replace(/\/$/, '');
            if (path === href)
            {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    (() => {
        const $header = $('.main-header');
        const $dropdownLinks = $header.find('.main-menu .nav-item.dropdown .nav-link');
        const $collapser = $header.find('.navbar-collapse');

        $dropdownLinks.on('click', e => {
            if ( document.documentElement.clientWidth >= 992 ) {
                return;
            }
            if ( e.currentTarget.classList.contains('show-dropdown') ) {
                e.currentTarget.classList.remove('show-dropdown');
            } else {
                $dropdownLinks.removeClass('show-dropdown');
                e.currentTarget.classList.add('show-dropdown');
            }
        });

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                $header.addClass('modal-transition');
                $header.addClass('modal-active');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                $dropdownLinks.removeClass('show-dropdown');
                $header.removeClass('modal-active');
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                $header.removeClass('modal-transition');
            });

        // click on "grey" closes menu
        $header.find('.header-overlay').on('click', () => {
            $collapser.collapse('hide');
        });
    })();

   

    $('.simple-guests').each((i, elem) =>
    {
        elem._simpleGuests = new SimpleGuests(elem, {
            btnValueTpl: (adults, children, infants, extras) =>
            {
                return `${adults + children + infants} ${guestsTranslations[language].guests}${extras ? ', ' + extras + ' ' + guestsTranslations[language].infants : ''}`;
            }
        });
    });

    $('.form-field').on('click', e =>
    {   
        if ($(e.target).hasClass('simple-guests-apply')) return
        if ($(e.target).hasClass('clear-param')) return

        e.stopImmediatePropagation();
        $(e.currentTarget).find('select').select2('open');
        if ($(e.currentTarget).find('.datepicker-range').length) $(e.currentTarget).find('.datepicker-range')[0]._flatpickr.open();
        if ($(e.currentTarget).find('.simple-guests').length) $(e.currentTarget).find('.simple-guests').dropdown('show');
        if ($(e.currentTarget).find('.form-guide').length)
        {
            let id = $($(e.currentTarget).find('.form-guide')[0]).data('fgid');
            formGuide[id].show();
        }
    });

     let formGuide = [];
    $('.form-guide').each((i, elem) =>
    {
        formGuide[i + 1] = new FormGuide(elem);
    });

    // home slider init
    $("#slider-home, #slider-page").lightSlider({
        item: 1,
        mode: 'fade',
        pager: false,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        //auto: false,
        pause: 8000,
        speed: 500,
        prevHtml: '<i class="las la-angle-left fa-4x"></i>',
        nextHtml: '<i class="las la-angle-right fa-4x"></i>'
    });

    // let $listSliders = 
    // home slider init
    $(".list-slider").lightSlider({
        item: 3,
        pager: true,
        slideMargin: 0,
        pauseOnHover: true,
        loop: false,
        prevHtml: '<i class="las la-angle-left fa-2x"></i>',
        nextHtml: '<i class="las la-angle-right fa-2x"></i>',
        responsive : [
            {
                breakpoint:1200,
                settings: {
                    item:2.4
                }
            },
            {
                breakpoint:992,
                settings: {
                    item:2
                }
            },
            {
                breakpoint:768,
                settings: {
                    item:1.4
                }
            },
            {
                breakpoint:450,
                settings: {
                    item:1
                }
            }
        ]
        // auto: false,
        // pause: 8000,
        // speed: 500,
        // prevHtml: '<i class="las la-angle-left fa-4x"></i>',
        // nextHtml: '<i class="las la-angle-right fa-4x"></i>'
        // onSliderLoad: function(el) {

        //     $(el).find(".list-item-slider").lightSlider({
        //         item: 1,
        //         // mode: 'slide',
        //         pager: false,
        //         slideMargin: 0,
        //         enableDrag: false,
        //         // loop: true,
        //         speed: 500,
        //         prevHtml: '<i class="las la-angle-left"></i>',
        //         nextHtml: '<i class="las la-angle-right"></i>'
        //     });
        // }
    });

    $(document).on('click', e => {
        
        let $elem = $(e.target);

        if ($elem.hasClass('search-component') )
        {
            $elem.parent().addClass('active');
            e.stopPropagation();
        }
        else $('.search-component').parent().removeClass('active');
        
    })

    $(document).on('click', 'table', function(e) {
        e.stopPropagation();
    });

    var s = $(".google-search");
    if (s.length) {
        var l = s.find("input.gsc-input");
        l.attr("placeholder", s.attr("google-search")),
        s.find(".google-search-icon").on("click", function() {
            s.hasClass("active") ? (s.find("a.gsst_a").trigger("click"),
            s.removeClass("active")) : (s.addClass("active").removeClass('load'),
            s.find("input.gsc-input").trigger("focus"))
        });
        var c = 0;
        l.on("input", function() {
            clearTimeout(c),
            c = setTimeout(function() {
                l.val() && s.find("button.gsc-search-button").trigger("click")
            }, 1e3)
        }),
        s.on("click", function(e) {
            return e.stopPropagation()
        }),
        $(document).on("click", function(e) {
            s.hasClass("active") && (s.find("a.gsst_a").trigger("click"),
            s.removeClass("active"))
        })
    }

     $(".list-item-slider").lightSlider({
                item: 1,
                // mode: 'slide',
                pager: false,
                slideMargin: 0,
                enableDrag: false,
                // loop: true,
                speed: 500,
                prevHtml: '<i class="las la-angle-left"></i>',
                nextHtml: '<i class="las la-angle-right"></i>'
            });


    // carousel init
    $(".carousel").lightSlider({
        item: 1,
        mode: 'fade',
        pager: false,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        auto: true,
        adaptiveHeight: true,
        pause: 8000,
        speed: 500,
        prevHtml: '<i class="las la-angle-left fa-2x"></i>',
        nextHtml: '<i class="las la-angle-right fa-2x"></i>'
    });

    // carousel init
    $(".review-slider").lightSlider({
        item: 1,
        mode: 'fade',
        pager: true,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        auto: false,
        adaptiveHeight: true,
        pause: 8000,
        speed: 500,
        prevHtml: '<i class="las la-angle-left fa-2x"></i>',
        nextHtml: '<i class="las la-angle-right fa-2x"></i>'
    });



    // if ($backgroundWithSlider.length)
    // {
    //     setTimeout(() => {
    //         $backgroundWithSlider.each((index, elem) => {
    //             debugger;
    //             let $elem = $(elem);
    //             console.log($elem.find('.page-carousel').height());
    //             $elem.css('margin-bottom', $elem.find('.page-carousel').height() / 2);
    //         })
    //     }, 100);
    // }
    // carousel init
    // $(".page-carousel").lightSlider({
    //     item: 1,
    //     mode: 'fade',
    //     pager: false,
    //     slideMargin: 0,
    //     pauseOnHover: true,
    //     loop: true,
    //     auto: true,
    //     adaptiveHeight: true,
    //     pause: 8000000,
    //     speed: 500,
    //     prevHtml: '<i class="las la-angle-left fa-2x"></i>',
    //     nextHtml: '<i class="las la-angle-right fa-2x"></i>'
    // });

    let compareItemsCount = $(".compare-list-item").length;

    if (compareItemsCount > 1)
    {

        $(".compare-list-items").lightSlider({
            item: (compareItemsCount > 3 ? 3 : 2),
            slideMargin: 0,
            pauseOnHover: true,
            loop: false,
            auto: false,
            pager: false,
            pause: 5000,
            speed: 500,
            enableDrag: false,
            prevHtml: '<span class="btn btn-primary"><i class="las la-angle-left fa-lg fa-fw"></i></span>',
            nextHtml: '<span class="btn btn-primary"><i class="las la-angle-right fa-lg fa-fw"></i></span>',
            responsive: [
                {
                    breakpoint: 974,
                    settings: {
                        item: 1
                    }
                }
            ]
        });

    }

    /* gallery */
    const lg = {};
    window.showGallery = (index, id) =>
    {
        index = +index || 0;
        if (lg[id])
        {
            lg[id].index = index;
            lg[id].build(index);
        } else
        {
            lg[id] = $('#' + id).lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($('[data-images-' + id + ']').attr('data-images-' + id))
            }).data('lightGallery');

        }
    };
    $('[data-gallery-id]').on('click', function (e)
    {
        e.stopPropagation();
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });

    /* end gallery */
    $('#cookie-bar-accept').on('click', function (e)
    {
        functions.setCookie('cookie_usage', 'accepted');
        $("#cookie-bar").addClass('d-none');
    });

    // slider list item init
   

    

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e =>
    {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });
    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = new Date();
    if (now > displayDate)
    {
        displayDate = now;
    }

    $('.datepicker-range').each((i, elem) =>
    {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
        const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
        const duration = Number($datepicker.attr('data-duration'));
        const position = $datepicker.attr('data-position') || 'auto';
        const minStayText = $datepicker.attr('data-minstay');
        $datepicker.flatpickr({
            mode: "range",
            showMonths: functions.isMobile() ? 1 : 2,
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            defaultDate: defaultDate,
            minDate: minDate && minDate >= now ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-arrow-left la-fw la-2x pr-2"></i>',
            nextArrow: '<i class="la la-arrow-right la-fw la-2x pl-2"></i>',
            locale: {
                rangeSeparator: ' - '
            },
            position: position,
            minStayText: minStayText ? minStayText : '',
            onDayCreate(dObj, dStr, fp, dayElem)
            {

                let minStay = 1;
                let to = new Date(maxDate);
                let weekday = new Date(dayElem.dateObj).getDay();
                weekday = '' + (weekday ? weekday : 7);
                to.setHours(0, 0, 0, 0);
                let onlyCheckInSelected = fp.selectedDates[0] && !fp.selectedDates[1];
                // let diff = globals.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                let from = dayElem.dateObj;
                let too = fp.selectedDates[0];
                // let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
                // let t = Date.UTC(too.getFullYear(), too.getMonth()+1, too.getDate());

                let diff = Math.round((from - too) / (1000 * 60 * 60 * 24));

                if (onlyCheckInSelected)
                {
                    if (Math.abs(diff) < minStay)
                    {
                        dayElem.className += ' flatpickr-disabled ';
                        if (diff)
                        {
                            if (minStayText)
                            {
                                $(dayElem).tooltip({
                                    title: minStayText.replace('{$min_stay}', minStay) || ''
                                });
                            }
                        }
                    }
                }

                if (dayElem.dateObj > to || (arrival.length && $.inArray(weekday, arrival) == -1))
                {
                    dayElem.classList.add('unselectable');
                }
            },
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });

    $('.datepicker')
        // to style clear toggler
        .on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)))
        .flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            disableMobile: true,
            prevArrow: '<i class="fa fa-chevron-circle-left fa-fw fa-2x pr-2"></i>',
            nextArrow: '<i class="fa fa-chevron-circle-right fa-fw fa-2x pl-2"></i>',
            onChange(selectedDates, dateStr, instance)
            {
                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst)
                {
                    delete instance._openByFirst;
                    return;
                }
                if ($first.attr('data-firstDate'))
                {
                    const $second = $first.closest('.form-row').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length)
                    {
                        const firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        const secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime())
                        {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0])
                            {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0])
                        {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0])
                {
                    $first.closest('.form-row').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance)
            {
                if (instance.input.getAttribute('data-secondDate'))
                {
                    const $first = $(instance.input).closest('.form-row').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length)
                    {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value)
                        {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(displayDate);
            }
        });

    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data =>
        {
            if (!data.element)
            {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            if ((data.id + '').split(':').length > 2)
            {
                $element.addClass('ms-3');
            } else
            {
                $element.addClass('fw-bold');
            }
            return $element;
        }
    };


    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem =>
    {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent() };
        config.allowClear = $elem.attr('data-allow-clear');

        const data = $elem.attr('data-data');
        if (data)
        {
            try
            {
                config.data = JSON.parse(data);
            } catch (e) { }
        }

        if ($elem.attr('data-template'))
        {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }

        if ($elem.attr('data-nosearch') !== undefined)
        {
            config.minimumResultsForSearch = Infinity;
        }

        const placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';

        $elem.select2(config)
            .on('select2:clear', () =>
            {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e =>
            {
                if ($elem[0].cleared)
                {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });

    let iframeLoadCounter = 0;
    $("#iframe-container iframe").on("load", function (e)
    {
        if (iframeLoadCounter > 0)
        {
            $("#iframe-container").removeClass('iframe-container-init');
            $('html, body').animate({
                scrollTop: $("#iframe-container").offset().top - 140
            }, 400, 'swing');
        }
        $(this).css('width', $("#iframe-container").width());
        iframeLoadCounter++;
    });

    functions.initCompare();

});

$(window).on('load', () =>
{

    // header custom search
    var cx = '015312865786210561267:ngixkjihjd4';
    $.getScript('https://cse.google.com/cse.js?cx=' + cx);

    // header off-screen
    const header = $('.main-header')[0];
    const navbar = $('.main-menu .navbar-collapse')[0];
    let scrolled = false;
    let lastScrollY = 0;
    const checkHeader = () =>
    {
        if (window.scrollY > lastScrollY)
        {
            header.classList.add('off-screen');
            header.classList.remove('modal-transition');
            header.classList.remove('modal-active');
            navbar.classList.remove('show');
            $(navbar).find('.show-dropdown').removeClass('show-dropdown');
        } else
        {
            header.classList.remove('off-screen');
        }

        if (window.scrollY < 100) 
        {
            header.classList.remove('shadow');
        }
        else 
        {
            header.classList.add('shadow');
        }
        
        lastScrollY = window.scrollY;
    }

    let timer = 0;
    $(window).on('scroll', () =>
    {
        if (!scrolled)
        { // annoying first scroll when page load already scrolled
            scrolled = true;
            return;
        } else
        {
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(checkHeader);
        }
    });



    if (window.__bootstrapBreakpointWatcherInit) return;
    window.__bootstrapBreakpointWatcherInit = true;

    
    let $pagesSlider = $(".page-carousel");
    let $contentSliders = [];
    let $attractionsSlider = null;
    if ($pagesSlider.length)
    {
        $pagesSlider.each((index, element) =>
        {
            let $elem = $(element);

            $contentSliders[index] = $elem.lightSlider({
                item: 1,
                mode: 'fade',
                pager: false,
                slideMargin: 0,
                pauseOnHover: true,
                loop: true,
                auto: true,
                adaptiveHeight: true,
                pause: 8000000,
                speed: 500,
                controls: false,
                onBeforeSlide: (el) =>
                {

                    let currSlide = el.getCurrentSlideCount();
                    let $parent = $(el).parents('.lSSlideOuter').last();
                    setTimeout(() =>
                    {
                        $($parent.next()).find('.current').html(String(currSlide).padStart(2, '0'));
                    }, 100);
                }
            });

            if ($elem.parents('#attractions').length) $attractionsSlider = $contentSliders[index];

            let $pager = $contentSliders[index].closest('.lSSlideOuter').next();

            let $parent = $elem.closest('.wp-block-custom-gutenberg-background:has(.page-carousel) ');
            $parent.length && $parent.css('margin-bottom', ($elem.parent().parent().parent().height() / 2) + 20);

            $pager.attr('data-slider-id', index);
        });

        let $contentSliderPagers = $('.lSAction.page-carousel-pager');

        $contentSliderPagers.find('.lSPrev').on('click', (data) =>
        {
            let sliderIndex = $(data.currentTarget).closest('.lSAction.page-carousel-pager').attr('data-slider-id');
            $contentSliders[sliderIndex].goToPrevSlide();
        });

        $contentSliderPagers.find('.lSNext').on('click', (data) =>
        {
            let sliderIndex = $(data.currentTarget).closest('.lSAction.page-carousel-pager').attr('data-slider-id');
            $contentSliders[sliderIndex].goToNextSlide();
        });
    }

    $('#attractions-tab').on('click', e => {
       if ($attractionsSlider) $attractionsSlider.refresh();
    })

    
    let current = null;
    let rAF = null;
    let lastEmitTs = 0;
    const minIntervalMs = 50; // ignore emits closer than this

    let entries = [];

    const styles = getComputedStyle(document.documentElement);
    for (let i = 0; i < styles.length; i++) {
        const p = styles[i];
        if (p.startsWith('--bs-breakpoint-')) {
            const v = parseFloat(styles.getPropertyValue(p));
            if (!Number.isNaN(v)) {
                entries.push([p.replace('--bs-breakpoint-', ''), v]);
            }
        }
    }
    entries.sort((a, b) => a[1] - b[1]);

    
    function getCurrent()
    {
        const w = window.innerWidth;
        for (let i = entries.length - 1; i >= 0; i--)
        {
            if (w >= entries[i][1]) return entries[i][0];
        }
        return 'unknown';
    }

    function getIsMobileWidth() {
        let sm = entries.filter(e => e[0] == 'md')[0];
        if (!sm) return window.innerWidth <= 768;
        return window.innerWidth <= sm[1];
    }

    function emitIfChanged()
    {
        const next = getCurrent();
        const isMobileWidth = getIsMobileWidth();
        const now = performance.now();
        if (next !== current && (now - lastEmitTs) > minIntervalMs)
        {
            const prev = current;
            current = next;
            lastEmitTs = now;
            window.dispatchEvent(new CustomEvent('breakpointChanged', {
                detail: { previous: prev, current: next, isMobileWidth: isMobileWidth }
            }));
        }
    }

    function onResize()
    {
        if (rAF) return;
        rAF = requestAnimationFrame(() =>
        {
            emitIfChanged();
            rAF = null;
        });
    }

    function init()
    {
        window.addEventListener('resize', onResize);
        emitIfChanged(); // initial
    }

    function destroy()
    {
        window.removeEventListener('resize', onResize);
    }

    window.bootstrapBreakpointWatcher = { init, destroy, getCurrentBreakpoint: getCurrent };
    init();

    let $mobileSliders = $('.mobile-slider');
    let mobileSliders = null;

    function initMobileSliders() {
        mobileSliders = $('.mobile-slider').lightSlider({
            item: 1,
            mode: 'slide',
            pager: true,
            slideMargin: 0,
            pauseOnHover: true,
            loop: true,
            auto: false,
            adaptiveHeight: true,
            pause: 8000,
            speed: 500,

        });
    }

    if (getIsMobileWidth() && $mobileSliders.length) initMobileSliders();

    window.addEventListener('breakpointChanged', e =>
    {
        let $backgroundWithSlider = $('.wp-block-custom-gutenberg-background:has(.page-carousel)');

        if (e.detail.isMobileWidth && mobileSliders == null) initMobileSliders();
        if (! e.detail.isMobileWidth && mobileSliders != null) 
        {
            mobileSliders.destroy();
            mobileSliders = null;
        }

        if ($backgroundWithSlider.length)
        {
            setTimeout(() => {
                $backgroundWithSlider.each((index, elem) => {
                    let $elem = $(elem);
                    let height = ($elem.find('.lSSlideOuter').parent().height() / 2) + 20;
                    if (! ['lg', 'xl', 'xxl'].includes(e.detail.current)) height = 100;
                    $elem.css('margin-bottom', height);
                })
            }, 100);
        }
    });



    window.showmoreobserver = lozad('.show-more', {
        rootMargin: '200px 200px',
        loaded: elem =>
        {
            $(elem).triggerHandler('lozadLoaded');
            let $showMore = $(elem);

            let height = $showMore.attr('data-height');
            if ($showMore.find('.show-more-content').outerHeight() < height)
            {
                $showMore.addClass('removeBefore');
                $showMore.next('.show-more-expand').remove();
                return;
            }

            let $breakpoint = $showMore.find('.show-more-breakpoint');
            if (height)
            {
                $showMore.css('max-height', +height);
            }
            else if ($breakpoint.length)
            {
                $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
            }
            else
            {
                let $maxHeight = functions.isMobile() ?
                    ($showMore.outerHeight() * 0.15) :
                    ($showMore.outerHeight() * 0.3);

                $showMore.css('max-height', $maxHeight);
            }

            $showMore.next('.show-more-expand').on('click tap', e =>
            {
                let $prevSibling = $(e.currentTarget).prev();
                let $maxHeight
                if ($prevSibling.hasClass('removeBefore'))
                {
                    let height = $prevSibling.attr('data-height');
                    let $breakpoint = $prevSibling.find('.show-more-breakpoint');
                    if (height)
                    {
                        $maxHeight = +height;
                    }
                    else if ($breakpoint.length)
                    {
                        $maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
                    }
                    else
                    {
                        $maxHeight = functions.isMobile() ?
                            ($prevSibling.outerHeight() * 0.15) :
                            ($prevSibling.outerHeight() * 0.3);
                    }
                    $prevSibling.css('max-height', $maxHeight);
                    $prevSibling.removeClass('removeBefore');
                    if ($prevSibling.hasClass('show-more-scroll'))
                    {
                        $('html, body').stop().animate({
                            scrollTop: $prevSibling.offset().top + $maxHeight - $(e.target).outerHeight(),
                        }, 0, 'linear');
                    }
                }
                else
                {
                    let $content = $prevSibling.find('.show-more-content');
                    $prevSibling.css('max-height', $content.outerHeight());
                    $prevSibling.addClass('removeBefore');
                }
            })
        }
    });


    window.showmoreobserver.observe();



    function cmplzTrimDocTitles() {
        $('.cmplz-documents a').each(function() {
            var t = $(this).text().trim();
            $(this).removeClass('opacity-0');
            var i = t.lastIndexOf(' ');
            if (i !== -1) $(this).text(t.substring(0, i));
        });
    }
   cmplzTrimDocTitles();



});